module.exports = __webpack_public_path__ + "assets/img/solution2.38674642.png";